// New translations for registration and email confirmation
export const en_new = {
    translations: {
        'registracija_sekme': 'Registration successful!',
        'vardas': 'First name',
        'pavarde': 'Last name',
        'ivestiVarda': 'Enter first name',
        'ivestiPavarde': 'Enter last name',
        'slaptazodzio_keitimas': 'Password change',
        'current_password': 'Current password',
        'neteisingas_dabartinis_slaptazodis': 'Incorrect current password',
        'profilis_atnaujintas': 'Profile successfully updated!',
        'keisti_slaptazodi': 'Change',
        'slaptazodzio_keitimo_aprasymas': 'We will send a password change link',
        'slaptazodzio_keitimo_nuoroda_issiusta': 'Password change link has been sent',
        'recaptcha_required': 'Please verify that you are not a robot',
        'registracijos_klaida': 'User with this email is already registered or not confirmed',
        'sistemos_klaida': 'A system error occurred. Please try again later.',
        'registruojama': 'Registering...',
        'privalomi_laukai': 'Please fill in all required fields',
        'prisijungimo_klaida': 'Login failed. Your account is not confirmed by administrator or check your email and password.',
        'jungiamasi': 'Connecting...',
        'user_exists': 'User with this email is already registered or not confirmed',
        'esu_organizacijos_atstovas': 'I am an authorized organization representative and can create an account on behalf of the organization',
        'email_patvirtinimas': 'Email confirmation',
        'tikrinamas_email': 'Verifying your email confirmation...',
        'email_patvirtintas': 'Your email has been successfully confirmed!',
        'email_patvirtintas_sekmes': 'Email successfully confirmed! Now the administrator needs to confirm your account.',
        'email_patvirtintas_admin': 'Administrator needs to confirm your account before you can use the system. This may take up to 24 hours.',
        'patvirtinimo_klaida': 'An error occurred while confirming the email.',
        'truksta_parametru': 'Missing required confirmation parameters.',
        'netinkamas_patvirtinimo_tipas': 'Invalid confirmation type. Please try again.',
        'grizti_i_prisijungima': 'Return to login page',
        'laukiama_admin_patvirtinimo': 'Your account is awaiting administrator confirmation',
        'jūsų_paskyra_laukia_administratoriaus_patvirtinimo': 'Your email has been successfully confirmed, but before using the system your account must be confirmed by an administrator.',
        'gauti_patvirtinimą_gali_užtrukti_iki_24_val': 'The confirmation process may take up to 24 hours. You will receive an email notification when your account is confirmed.',
        'account_not_confirmed_by_admin': 'Your account has not yet been confirmed by the administrator. You can use the system once the administrator confirms your account.',
        'vartotojų_patvirtinimas': 'User confirmation',
        'nauji_vartotojai_turi_būti_patvirtinti_prieš_naudojimą': 'New users must be confirmed before they can use the system.',
        'patvirtinti_vartotojai_gali_prisijungti_ir_naudotis_sistema': 'Confirmed users can log in and use the system.',
        'nepatvirtinti_vartotojai_negali_prisijungti': 'Unconfirmed users cannot fully use the system.',
        'vartotojai_kurių_el_paštas_nepatvirtintas_gali_neturėti_prieigos': 'Users whose email is not confirmed may not have access to the system.',
        'registration_success_email_confirmation': 'Registration successful! Check your email to confirm your account.',
        'patvirtinti_imone': 'Confirm company',
        'Vartotojas sėkmingai patvirtintas': 'Company successfully confirmed!',
        'Klaida patvirtinant vartotoją': 'Error confirming company. Please try again.',
        'galioja_iki': 'Valid until',
        'galiojanti': 'Valid',
        'negaliojanti': 'Invalid',
        'prenumeratos_info': 'Select subscription type and save changes',
        'Įmonė sėkmingai patvirtinta!': 'Company successfully confirmed!',
        // OTP Password Reset translations
        'send_verification_code': 'Send verification code',
        'verification_code': 'Verification code',
        'otp_sent': 'Verification code sent to your email',
        'enter_verification_code': 'Enter the 6-digit code from your email',
        'verify_code': 'Verify code',
        'invalid_otp': 'Invalid or expired verification code',
        'otp_verified': 'Code verified successfully',
        'otp_required': 'Please enter the 6-digit code',
        'send_code': 'Send code',
        'resend_code': 'Resend code',
        'resend_code_in': 'You can resend the code in',
        'otp_verification_desc': 'Enter the 6-digit code you received',
        'enter_6_digit_code': 'Enter 6-digit code',
        'enter_new_password': 'Enter your new password',
        'new_password': 'New password',
        'confirm_password': 'Confirm password',
        'password_required': 'Password is required',
        'passwords_dont_match': 'Passwords do not match',
        'password_too_short': 'Password must be at least 6 characters',
        'password_updated': 'Password updated successfully',
        'password_update_failed': 'Failed to update password',
        'update_password': 'Update password',
        // Two-step confirmation translations
        'confirm_password_reset': 'Confirm Password Reset',
        'click_below_to_reset_password': 'Click the button below to proceed with resetting your password.',
        'link_expires_warning': 'This link will expire after use or after 1 hour.',
        'confirm_reset': 'Confirm Reset',
        'cancel': 'Cancel',
        'security_notice': 'This extra step helps protect your account from unauthorized access.',
        'invalid_reset_link': 'Invalid password reset link',
        'reset_link_error': 'Error processing reset link',
        'invalid_link': 'Invalid Link',
        'redirecting': 'Redirecting',
        'Metai pridėti. Nepamirškite paspausti "Išsaugoti" mygtuką, kad pakeitimai būtų išsaugoti.': 'Years added. Don\'t forget to click the "Save" button to save the changes.',
        'login_error': 'Password is incorrect or account is not confirmed',
        'db_migration_info': 'If you haven\'t changed your password yet, please click "Forgot Password" and we will send you a link to change your password. The database was migrated to other servers, so you need to create a new password.',
        
        // Password reset translations
        'reset_link_sent': 'Password reset link sent',
        'reset_link_sent_desc': 'Password reset link has been sent to your email. Please check your inbox.',
        'prasyti_atstatymo': 'Reset Password',
        'grizti_i_prisijungima': 'Return to login',
        'tikrinama_sesija': 'Checking session...',
        'slaptazodis_pakeistas_aprasas': 'Your password has been successfully changed. You can now log in with your new password.',
        'keitimas_uztruko': 'Password change took too long. Please try again or contact an administrator.',
        'processing': 'Processing...',
        'forgotPass.invalidEmail': 'Invalid email format',
        'forgotPass.resetLinkSent': 'Password reset link sent',
        'forgotPass.resetError': 'Error sending reset link',
        'ivestkiteEmail': 'Please enter a valid email',
        
        // Company management translations
        'laukia_patvirtinimo': 'Awaiting approval',
        'aktyvi': 'Active',
        'pasibaigusi': 'Expired',
        'patvirtinta': 'Approved',
        'nepatvirtinta': 'Not approved',
        'neribota': 'Unlimited',
        'paspauskite_patvirtinti_kad_aktyvuoti': 'Click "Approve Company" button below',
        'pakeitimai_issaugoti': 'Changes saved!',
        'prideti_metus': 'Extend year'
    }
};
